import Layout from '@/components/common/index.vue'

const routeManagementRoutes: any = [
  {
    path: '/st-site',
    component: Layout,
    name: 'RouteManagement',
    children: [
      {
        path: '/st-site/routeManagement/admissionFenceMapDisplay',
        name: 'AdmissionFenceMapDisplay',
        component: () => import(/* webpackChunkName: "admissionFenceMapDisplay" */ '../views/admissionFenceMapDisplay/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-site/personnelManagement/driverMap',
        name: 'DriverMap',
        component: () => import(/* webpackChunkName: "test" */ '../views/driverMap/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-itms/overseasTrans/vehicleTrajectory',
        name: 'VehicleTrajectory',
        component: () => import(/* webpackChunkName: "VehicleTrajectory" */ '../views/vehicleTrajectory/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-3pl/trajectoManage/endToEndTracking',
        name: 'EndToEndTracking',
        component: () => import(/* webpackChunkName: "endToEndTracking" */ '../views/endToEndTracking/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-site/staff',
        name: 'Staff',
        component: () => import(/* webpackChunkName: "Staff" */ '../views/Staff/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-3pl/staff',
        name: 'PlStaff',
        component: () => import(/* webpackChunkName: "Staff" */ '../views/Staff/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-itms/staff',
        name: 'ItmsStaff',
        component: () => import(/* webpackChunkName: "Staff" */ '../views/Staff/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-dms/staff',
        name: 'IDmsStaff',
        component: () => import(/* webpackChunkName: "Staff" */ '../views/Staff/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-dms/dmsTrajectoManage/endToEndTracking',
        name: 'dmsTrajectoManage',
        component: () => import(/* webpackChunkName: "dmsTrajectoManage" */ '../views/endToEndTracking/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-dms/mapTracking/:id',
        name: 'idmsTrajectoManage',
        component: () => import(/* webpackChunkName: "isiteTrajectoManage" */ '../views/endToEndTracking/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      },
      {
        path: '/st-site/mapTracking/:id',
        name: 'isiteTrajectoManage',
        component: () => import(/* webpackChunkName: "isiteTrajectoManage" */ '../views/endToEndTracking/index.vue'),
        meta: { tabGroup: 'DictionaryInfo' }
      }
    ]
  }
]

export default routeManagementRoutes
